import { createAction, props } from '@ngrx/store';

export const setLoadedProductDiscounts = createAction(
  '[Merchandise Prices] Merchandise prices product discounts are loaded',
  props<{ [productId: string]: [discount: number] }>(),
);
